import { render, staticRenderFns } from "./claim-confirm.vue?vue&type=template&id=bbb65714&scoped=true&"
import script from "./claim-confirm.vue?vue&type=script&lang=js&"
export * from "./claim-confirm.vue?vue&type=script&lang=js&"
import style0 from "./claim-confirm.vue?vue&type=style&index=0&id=bbb65714&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb65714",
  null
  
)

export default component.exports